// Used in distributor.component.html, student.component.html, teacher.component.html

// Angular
import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { Router } from "@angular/router";

// Services/Types/Helpers
import { OpenSidePanelRightHelper } from "#helpers/open-side-panel-right.helper";

// RXJS/Store
import * as loginStore from "#login/store";
import { Store } from "@ngrx/store";

@Component({
    selector: "side-panel-right",
    templateUrl: "./side-panel-right.component.html",
    styleUrls: ["./side-panel-right.component.scss"],
    standalone: false
})
export class SidePanelRightComponent implements OnInit {
    @Input() creatingLesson: boolean;
    @Input() creatingActivity: boolean;
    @Input() assignCartOpen: boolean;

    @Output() sidePanelRightClose = new EventEmitter<void>();
    @Output() setTab = new EventEmitter<string>();

    tab: string;

    constructor(
        private sidePanelRightHelper: OpenSidePanelRightHelper,
        public store_login: Store<loginStore.UserState>,
        private router: Router
    ) {}

    ngOnInit() {
        this.sidePanelRightHelper.currentTab.subscribe((tab) => {
            this.tab = tab;
            this.setTab.emit(this.tab);
        });
    }

    onSidePanelRightClose() {
        this.sidePanelRightClose.emit();
    }

    logout() {
        this.store_login.dispatch(loginStore.userLogout({ signout: true }));
        this.router.navigate(["/login"]);
    }
}
